export const localization = {
  pt: {
    locale: 'pt_BR',
    step: {
      next: 'Próximo',
      back: 'Voltar',
      finish: 'Finalizar',
    },
    upload: {
      title: 'Upload do certificado',
      subtitle: 'Arraste o certificate .pfx ou clique para selecionar',
      passwordLabel: 'Senha',
      passwordPlaceholder: 'Insira a senha do certificado',
      error: 'Ocorreu um erro ao fazer o upload do arquivo, verifique se o certificado e a senha estão corretos',
      success: 'Certificado enviado com sucesso',
      typeError: 'O arquivo deve ser do tipo .pfx',
      sizeError: 'O arquivo deve ter no máximo 10MB',
    },
    info: {
      title: 'Informações do certificado',
      descriptionLabel: 'Descrição',
      descriptionPlaceholder: 'Insira a descrição do certificado',
      urlLabel: 'URL',
      urlPlaceholder: 'Insira a URL do certificado',
      validCertificateDescriptionError: 'Insira uma descrição válida para o certificado',
      validUrlerror: 'Insira uma URL HTTPS válida',
      descriptionMaxErrorMessage: 'O campo deve ter no máximo 50 caracteres',
      urlMaxErrorMessage: 'O campo deve ter no máximo 100 caracteres',
    },
    confirmation: {
      title: 'Conferência',
      subtitle: 'Confirme as informações do certificado',
      file: 'Arquivo',
      description: 'Descrição',
      url: 'URL',
    },
  },
  en: {
    locale: 'en_US',
    step: {
      next: 'Next',
      back: 'Back',
      finish: 'Finish',
    },
    upload: {
      title: 'Upload certificate',
      subtitle: 'Drag the .pfx file or click to select',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Enter the certificate password',
      error: 'An error occurred while uploading the file, check that the certificate and password are correct',
      success: 'Certificate uploaded successfully',
      typeError: 'The file must be of type .pfx',
      sizeError: 'The file must be a maximum of 10MB',
    },
    info: {
      title: 'Certificate information',
      descriptionLabel: 'Description',
      descriptionPlaceholder: 'Enter the certificate description',
      urlLabel: 'URL',
      urlPlaceholder: 'Enter the certificate URL',
      validCertificateDescriptionError: 'Enter a valid description for the certificate',
      validUrlerror: 'Enter a valid HTTPS URL',
      descriptionMaxErrorMessage: 'The field must have a maximum of 50 characters',
      urlMaxErrorMessage: 'The field must have a maximum of 100 characters',
    },
    confirmation: {
      title: 'Confirmation',
      subtitle: 'Confirm the certificate information',
      file: 'File',
      description: 'Description',
      url: 'URL',
    },
  },
  es: {
    locale: 'es_ES',
    step: {
      next: 'Siguiente',
      back: 'Atrás',
      finish: 'Finalizar',
    },
    upload: {
      title: 'Subir certificado',
      subtitle: 'Arrastre el archivo .pfx o haga clic para seleccionar',
      passwordLabel: 'Contraseña',
      passwordPlaceholder: 'Introduzca la contraseña del certificado',
      error: 'Se produjo un error al cargar el archivo, verifique que el certificado y la contraseña sean correctos',
      success: 'Certificado subido con éxito',
      typeError: 'El archivo debe ser de tipo .pfx',
      sizeError: 'El archivo debe tener un máximo de 10MB',
    },
    info: {
      title: 'Información del certificado',
      descriptionLabel: 'Descripción',
      descriptionPlaceholder: 'Introduzca la descripción del certificado',
      urlLabel: 'URL',
      urlPlaceholder: 'Introduzca la URL del certificado',
      validCertificateDescriptionError: 'Introduzca una descripción válida para el certificado',
      validUrlerror: 'Introduzca una URL HTTPS válida',
      maxErrorMessage: 'El campo debe tener un máximo de 50 caracteres',
      urlMaxErrorMessage: 'El campo debe tener un máximo de 100 caracteres',
    },
    confirmation: {
      title: 'Confirmación',
      subtitle: 'Confirme la información del certificado',
      file: 'Archivo',
      description: 'Descripción',
      url: 'URL',
    },
  },
};
